import ThemeStripes from '../cabinet/ThemeStripes';

/** Подвал экранов вне кабинета. Полоски — в industrial и mono; в индиго их нет, как в кабинете. */
export default function PortalFooter({ stripes }: { stripes: boolean }) {
  return (
    <footer className="py-5 border-t border-surface-3 flex items-center justify-center gap-3 relative z-10">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/20 to-transparent" />
      {stripes && <ThemeStripes className="absolute left-8 top-1/2 -translate-y-1/2 hidden sm:flex" />}
      <span className="text-xs text-foreground-300 tracking-widest uppercase">© 2026 Корпоративный портал</span>
      <span className="text-foreground-300">·</span>
      <span className="text-xs text-foreground-300 tracking-widest">v1.0.0</span>
    </footer>
  );
}
